/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MemberPaymentItem } from './MemberPaymentItem';
import {
    MemberPaymentItemFromJSON,
    MemberPaymentItemFromJSONTyped,
    MemberPaymentItemToJSON,
} from './MemberPaymentItem';
import type { MemberPaymentMethod } from './MemberPaymentMethod';
import {
    MemberPaymentMethodFromJSON,
    MemberPaymentMethodFromJSONTyped,
    MemberPaymentMethodToJSON,
} from './MemberPaymentMethod';

/**
 * Member Payment Schema
 * @export
 * @interface MemberPayment
 */
export interface MemberPayment {
    /**
     * Member Payment ID
     * @type {string}
     * @memberof MemberPayment
     */
    id: string;
    /**
     * Member ID
     * @type {string}
     * @memberof MemberPayment
     */
    memberId: string;
    /**
     * Payment Amount in Cents
     * @type {number}
     * @memberof MemberPayment
     */
    paymentAmountCents: number;
    /**
     * Notes
     * @type {string}
     * @memberof MemberPayment
     */
    notes: string;
    /**
     * 
     * @type {MemberPaymentItem}
     * @memberof MemberPayment
     */
    paymentItem: MemberPaymentItem;
    /**
     * 
     * @type {MemberPaymentMethod}
     * @memberof MemberPayment
     */
    paymentMethod: MemberPaymentMethod;
    /**
     * Payment Reference
     * @type {string}
     * @memberof MemberPayment
     */
    paymentReference: string;
    /**
     * Payment Date
     * @type {Date}
     * @memberof MemberPayment
     */
    paymentDate: Date;
    /**
     * Refund Date
     * @type {Date}
     * @memberof MemberPayment
     */
    refundDate: Date | null;
    /**
     * Refund Reason
     * @type {string}
     * @memberof MemberPayment
     */
    refundReason: string;
    /**
     * Refund Amount in Cents
     * @type {number}
     * @memberof MemberPayment
     */
    refundAmountCents: number | null;
    /**
     * Created Date
     * @type {Date}
     * @memberof MemberPayment
     */
    createdDate: Date;
    /**
     * Updated Date
     * @type {Date}
     * @memberof MemberPayment
     */
    updatedDate: Date;
}



/**
 * Check if a given object implements the MemberPayment interface.
 */
export function instanceOfMemberPayment(value: object): value is MemberPayment {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('memberId' in value) || value['memberId'] === undefined) return false;
    if (!('paymentAmountCents' in value) || value['paymentAmountCents'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    if (!('paymentItem' in value) || value['paymentItem'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('paymentDate' in value) || value['paymentDate'] === undefined) return false;
    if (!('refundDate' in value) || value['refundDate'] === undefined) return false;
    if (!('refundReason' in value) || value['refundReason'] === undefined) return false;
    if (!('refundAmountCents' in value) || value['refundAmountCents'] === undefined) return false;
    if (!('createdDate' in value) || value['createdDate'] === undefined) return false;
    if (!('updatedDate' in value) || value['updatedDate'] === undefined) return false;
    return true;
}

export function MemberPaymentFromJSON(json: any): MemberPayment {
    return MemberPaymentFromJSONTyped(json, false);
}

export function MemberPaymentFromJSONTyped(json: any, ignoreDiscriminator: boolean): MemberPayment {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'memberId': json['member_id'],
        'paymentAmountCents': json['payment_amount_cents'],
        'notes': json['notes'],
        'paymentItem': MemberPaymentItemFromJSON(json['payment_item']),
        'paymentMethod': MemberPaymentMethodFromJSON(json['payment_method']),
        'paymentReference': json['payment_reference'],
        'paymentDate': (new Date(json['payment_date'])),
        'refundDate': (json['refund_date'] == null ? null : new Date(json['refund_date'])),
        'refundReason': json['refund_reason'],
        'refundAmountCents': json['refund_amount_cents'],
        'createdDate': (new Date(json['created_date'])),
        'updatedDate': (new Date(json['updated_date'])),
    };
}

export function MemberPaymentToJSON(value?: MemberPayment | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'member_id': value['memberId'],
        'payment_amount_cents': value['paymentAmountCents'],
        'notes': value['notes'],
        'payment_item': MemberPaymentItemToJSON(value['paymentItem']),
        'payment_method': MemberPaymentMethodToJSON(value['paymentMethod']),
        'payment_reference': value['paymentReference'],
        'payment_date': ((value['paymentDate']).toISOString()),
        'refund_date': (value['refundDate'] == null ? null : (value['refundDate'] as any).toISOString()),
        'refund_reason': value['refundReason'],
        'refund_amount_cents': value['refundAmountCents'],
        'created_date': ((value['createdDate']).toISOString()),
        'updated_date': ((value['updatedDate']).toISOString()),
    };
}

